module.exports = __webpack_public_path__ + "img/focus.60930c97.svg";